/** Situações das regiões */
export interface RegiaoSituacao {
    id: number;
    nome: string;
}

export const regiaoSituacaoAtiva: RegiaoSituacao = {
    id: 1,
    nome: 'Ativa'
};

export const regiaoSituacaoInativa: RegiaoSituacao = {
    id: 2,
    nome: 'Inativa'
};

export const regiaoSituacoes: RegiaoSituacao[] = [
    regiaoSituacaoAtiva,
    regiaoSituacaoInativa
];


/** Verifica se a situação da região é ativa */
export function isSituacaoAtiva(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === regiaoSituacaoAtiva.id;
}

/** Verifica se a situação da região é inativa */
export function isSituacaoInativa(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === regiaoSituacaoInativa.id;
}
